import { useLocalStorage } from '@rehooks/local-storage';

export const useDarkMode = () => {
  return useLocalStorage('ZDarkMode');
};
